import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  author: string;
  views: string;
  tags: string[];
}

export default function ArticleCard({ id, title, excerpt, image, date, author, views, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
      aria-label={`阅读 ${title}`}
    >
      <div className="w-full sm:w-48 md:w-56 flex-shrink-0">
        <div className="relative overflow-hidden rounded-lg aspect-video sm:aspect-[4/3]">
          <img
            src={image}
            alt={title}
            title={`西瓜视频 - ${title}`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views}
          </span>
        </div>
        <h3 className="text-base md:text-lg font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
          {excerpt}
        </p>
        <div className="flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}